import { IsDefined, IsString } from 'class-validator';

export class RefreshJwtTokenRequest {
    @IsDefined()
    @IsString()
    public refreshToken: string;

    constructor(data?: Partial<RefreshJwtTokenRequest>) {
        this.refreshToken = data?.refreshToken;
    }
}
